/**
 * Sum amount fields from reimbursement rows (API returns amount as a decimal string).
 * @param {{ amount?: string|number }[]} rows
 * @returns {number}
 */
export function sumReimbursementAmounts(rows) {
  if (!rows?.length) return 0
  return rows.reduce((sum, row) => {
    const n = parseFloat(row.amount)
    return sum + (Number.isNaN(n) ? 0 : n)
  }, 0)
}

/**
 * @param {number} total
 * @returns {string} e.g. "1,234.56"
 */
export function formatReimbursementTotal(total) {
  if (Number.isNaN(total)) return "0.00"
  return total.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
